const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: State-Space Anatomy ────────────────────────────────
function DiagramSSAnatomy() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>State-Space Equations — Anatomy of ẋ = Ax + Bu,  y = Cx + Du</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="a1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="a2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
          <marker id="a3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#27ae60"/>
          </marker>
          <marker id="a4" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#e07b00"/>
          </marker>
        </defs>

        {/* Central equation box */}
        <rect x={240} y={18} width={420} height={64} rx={6} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={450} y={44} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">ẋ(t) = A·x(t) + B·u(t)</text>
        <text x={450} y={70} textAnchor="middle" fontSize="15" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">y(t) = C·x(t) + D·u(t)</text>

        {/* Matrix dimension labels */}
        {[
          { x:310, y:100, w:52, h:38, fill:'#fff5f5', bc:'#c0392b', label:'A', sub:'n×n', desc:'System matrix\n(dynamics / coupling)' },
          { x:390, y:100, w:52, h:38, fill:'#eaf3ff', bc:'#2E75B6', label:'B', sub:'n×p', desc:'Input matrix\n(how u drives states)' },
          { x:470, y:100, w:52, h:38, fill:'#f0fff4', bc:'#27ae60', label:'C', sub:'q×n', desc:'Output matrix\n(which states observed)' },
          { x:550, y:100, w:52, h:38, fill:'#fff9e6', bc:'#e07b00', label:'D', sub:'q×p', desc:'Feedthrough matrix\n(direct u→y path)' },
        ].map(({ x, y, w, h, fill, bc, label, sub, desc }) => (
          <g key={label}>
            <rect x={x} y={y} width={w} height={h} rx={4} fill={fill} stroke={bc} strokeWidth="2"/>
            <text x={x+w/2} y={y+18} textAnchor="middle" fontSize="16" fill={bc} fontWeight="700" fontFamily="'Courier New',monospace">{label}</text>
            <text x={x+w/2} y={y+32} textAnchor="middle" fontSize="10" fill={bc}>{sub}</text>
            <text x={x+w/2} y={y+58} textAnchor="middle" fontSize="9.5" fill="#555" textDecoration="underline">{desc.split('\n')[0]}</text>
            <text x={x+w/2} y={y+70} textAnchor="middle" fontSize="9" fill="#777">{desc.split('\n')[1]}</text>
          </g>
        ))}

        {/* Vector labels: x, u, y */}
        {/* x - state vector */}
        <rect x={30} y={155} width={110} height={80} rx={5} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
        <text x={85} y={178} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">x ∈ ℝⁿ</text>
        <text x={85} y={196} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">State Vector</text>
        <text x={85} y={212} textAnchor="middle" fontSize="10" fill="#555">n state variables</text>
        <text x={85} y={226} textAnchor="middle" fontSize="10" fill="#555">(system memory)</text>
        <line x1={140} y1={195} x2={238} y2={195} stroke="#c0392b" strokeWidth="2" markerEnd="url(#a1)"/>

        {/* u - input vector */}
        <rect x={30} y={255} width={110} height={70} rx={5} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
        <text x={85} y={276} textAnchor="middle" fontSize="14" fill="#2E75B6" fontWeight="700" fontFamily="'Courier New',monospace">u ∈ ℝᵖ</text>
        <text x={85} y={294} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">Input Vector</text>
        <text x={85} y={310} textAnchor="middle" fontSize="10" fill="#555">p control inputs</text>
        <line x1={140} y1={290} x2={238} y2={290} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#a2)"/>

        {/* Central block */}
        <rect x={238} y={155} width={424} height={160} rx={6} fill="#fff" stroke="#f0cece" strokeWidth="2"/>
        <text x={450} y={192} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">STATE-SPACE MODEL</text>

        {/* Integrator symbol */}
        <rect x={360} y={205} width={180} height={50} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={450} y={227} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontFamily="'Courier New',monospace">∫ dt   (state integrator)</text>
        <text x={450} y={245} textAnchor="middle" fontSize="10" fill="#555">x(t) = x(0) + ∫ ẋ(τ)dτ</text>

        {/* ẋ label */}
        <text x={295} y={233} fontSize="13" fill="#c0392b" fontWeight="700" fontFamily="'Courier New',monospace">ẋ→</text>
        <text x={556} y={233} fontSize="13" fill="#c0392b" fontWeight="700" fontFamily="'Courier New',monospace">→x</text>

        {/* y - output vector */}
        <rect x={760} y={185} width={120} height={70} rx={5} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
        <text x={820} y={208} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700" fontFamily="'Courier New',monospace">y ∈ ℝq</text>
        <text x={820} y={226} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">Output Vector</text>
        <text x={820} y={242} textAnchor="middle" fontSize="10" fill="#555">q measured outputs</text>
        <line x1={662} y1={220} x2={758} y2={220} stroke="#27ae60" strokeWidth="2" markerEnd="url(#a3)"/>

        {/* n, p, q dimension note */}
        <rect x={238} y={320} width={424} height={16} rx={2} fill="#f0cece" opacity="0.3"/>
        <text x={450} y={332} textAnchor="middle" fontSize="10" fill="#7B0D0D">n = state order   |   p = number of inputs   |   q = number of outputs   |   D=0 for strictly proper systems</text>
      </svg>
      <div style={S.dCaption}>The state-space model packages an nth-order system into two matrix equations. The state equation ẋ = Ax + Bu describes how the n state variables evolve. The output equation y = Cx + Du maps states and inputs to the q measured outputs. All of the system's dynamics are encoded in four constant matrices: A (system), B (input), C (output), D (feedthrough).</div>
    </div>
  );
}

// ── Diagram 2: Signal-Flow / Block Diagram of State-Space ─────────
function DiagramSSBlockDiagram() {
  const W = 900, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>State-Space Block Diagram — Signal Flow Between Matrices</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="bd1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="bd2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
          <marker id="bd3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#27ae60"/>
          </marker>
          <marker id="bd4" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#e07b00"/>
          </marker>
        </defs>

        {/* u(t) input */}
        <text x={14} y={128} fontSize="12" fill="#555">u(t)</text>
        <line x1={40} y1={124} x2={80} y2={124} stroke="#c0392b" strokeWidth="2" markerEnd="url(#bd1)"/>

        {/* Pick-off node for D path */}
        <circle cx={88} cy={124} r={4} fill="#c0392b"/>

        {/* B matrix block */}
        <rect x={100} y={104} width={70} height={40} rx={4} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
        <text x={135} y={128} textAnchor="middle" fontSize="15" fill="#2E75B6" fontWeight="700" fontFamily="'Courier New',monospace">B</text>

        {/* Summing junction */}
        <line x1={170} y1={124} x2={204} y2={124} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#bd2)"/>
        <circle cx={218} cy={124} r={14} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
        <text x={218} y={129} textAnchor="middle" fontSize="14" fill="#c0392b" fontWeight="700">Σ</text>

        {/* Integrator */}
        <line x1={232} y1={124} x2={268} y2={124} stroke="#c0392b" strokeWidth="2" markerEnd="url(#bd1)"/>
        <text x={250} y={117} fontSize="10" fill="#555">ẋ</text>
        <rect x={268} y={104} width={80} height={40} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={308} y={126} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">1/s</text>
        <text x={308} y={140} textAnchor="middle" fontSize="10" fill="#c0392b">(integrator)</text>

        {/* x pick-off */}
        <line x1={348} y1={124} x2={400} y2={124} stroke="#c0392b" strokeWidth="2" markerEnd="url(#bd1)"/>
        <circle cx={400} cy={124} r={4} fill="#c0392b"/>
        <text x={368} y={117} fontSize="10" fill="#555">x</text>

        {/* C matrix */}
        <line x1={400} y1={124} x2={440} y2={124} stroke="#c0392b" strokeWidth="2" markerEnd="url(#bd1)"/>
        <rect x={440} y={104} width={70} height={40} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
        <text x={475} y={128} textAnchor="middle" fontSize="15" fill="#27ae60" fontWeight="700" fontFamily="'Courier New',monospace">C</text>

        {/* Output summing junction */}
        <line x1={510} y1={124} x2={544} y2={124} stroke="#27ae60" strokeWidth="2" markerEnd="url(#bd3)"/>
        <circle cx={558} cy={124} r={14} fill="#fff" stroke="#27ae60" strokeWidth="2"/>
        <text x={558} y={129} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">Σ</text>

        {/* y output */}
        <line x1={572} y1={124} x2={620} y2={124} stroke="#27ae60" strokeWidth="2" markerEnd="url(#bd3)"/>
        <text x={626} y={128} fontSize="12" fill="#555">y(t)</text>

        {/* A matrix feedback */}
        <line x1={400} y1={124} x2={400} y2={200} stroke="#c0392b" strokeWidth="2"/>
        <line x1={400} y1={200} x2={218} y2={200} stroke="#c0392b" strokeWidth="2"/>
        <line x1={218} y1={200} x2={218} y2={140} stroke="#c0392b" strokeWidth="2" markerEnd="url(#bd1)"/>
        <rect x={270} y={180} width={70} height={36} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
        <text x={305} y={202} textAnchor="middle" fontSize="15" fill="#c0392b" fontWeight="700" fontFamily="'Courier New',monospace">A</text>
        <text x={170} y={195} fontSize="10" fill="#c0392b" fontStyle="italic">state feedback</text>
        <text x={218} y={182} fontSize="10" fill="#c0392b">+</text>

        {/* D matrix direct path */}
        <line x1={88} y1={124} x2={88} y2={60} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3"/>
        <line x1={88} y1={60} x2={558} y2={60} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3"/>
        <line x1={558} y1={60} x2={558} y2={108} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#bd4)"/>
        <rect x={290} y={40} width={60} height={36} rx={4} fill="#fff9e6" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={320} y={62} textAnchor="middle" fontSize="14" fill="#e07b00" fontWeight="700" fontFamily="'Courier New',monospace">D</text>
        <text x={558} y={114} textAnchor="middle" fontSize="10" fill="#e07b00">+</text>
        <text x={320} y={30} textAnchor="middle" fontSize="10" fill="#e07b00" fontStyle="italic">direct feedthrough (often D=0)</text>

        {/* Right legend */}
        <rect x={660} y={20} width={228} height={H-30} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={774} y={40} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Matrix Roles</text>
        {[
          { y:50, col:'#c0392b', bg:'#fff5f5', bc:'#c0392b', txt:['A  — governs autonomous','dynamics and inter-state coupling'] },
          { y:98, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', txt:['B  — distributes each input','component to state derivatives'] },
          { y:146, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60', txt:['C  — selects which linear','combinations of states are measured'] },
          { y:194, col:'#e07b00', bg:'#fff9e6', bc:'#e07b00', txt:['D  — instantaneous input-to-','output path (zero in most plants)'] },
          { y:246, col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6', txt:['1/s  — integrator: each state','is integral of its derivative'] },
        ].map(({ y, col, bg, bc, txt }) => (
          <g key={y}>
            <rect x={666} y={y} width={216} height={44} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {txt.map((t, i) => <text key={i} x={672} y={y+16+i*16} fontSize="10.5" fill={col} fontWeight={i===0?'700':'400'}>{t}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The block diagram makes the signal flow explicit. Input u passes through B to form part of ẋ. The integrator 1/s converts ẋ to the state x. Matrix A feeds x back to the ẋ summing junction, creating the internal dynamics loop. C projects x to the output; D creates a direct path from u to y that bypasses the dynamics entirely.</div>
    </div>
  );
}

// ── Diagram 3: State Trajectory in Phase Plane ────────────────────
function DiagramPhasePortrait() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // Stable spiral: A = [[-0.3,  1.2], [-1.2, -0.3]]
  const cx1 = 10 + PW / 2, cy1 = 160, sc = 52;
  const spiralPts = [];
  let sx = 2.2, sy = 0.5;
  for (let i = 0; i < 300; i++) {
    spiralPts.push([cx1 + sx * sc, cy1 - sy * sc]);
    const dx = -0.3 * sx + 1.2 * sy;
    const dy = -1.2 * sx - 0.3 * sy;
    sx += dx * 0.04;
    sy += dy * 0.04;
  }

  // Saddle point trajectories
  const cx2 = PW + 40 + PW / 2, cy2 = 160;
  const saddleLines = [];
  for (let dir = 0; dir < 8; dir++) {
    const angle = (dir / 8) * Math.PI * 2;
    const pts = [];
    let px = Math.cos(angle) * 0.3, py = Math.sin(angle) * 0.3;
    for (let i = 0; i < 60; i++) {
      pts.push([cx2 + px * sc, cy2 - py * sc]);
      const dx = 1.0 * px + 0.0 * py;
      const dy = 0.0 * px - 1.0 * py;
      px += dx * 0.06;
      py += dy * 0.06;
      if (Math.abs(px) > 3.5 || Math.abs(py) > 3.5) break;
    }
    saddleLines.push({ pts, stable: Math.abs(Math.cos(angle)) < 0.2 });
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>State Trajectories in the Phase Plane — Stable Spiral vs. Saddle Point</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="pp1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#c0392b"/>
          </marker>
          <marker id="pp2" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#2E75B6"/>
          </marker>
          <marker id="ppa" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Stable spiral */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={cx1} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Stable Spiral (Complex poles, Re&lt;0)</text>

        {/* Axes */}
        <line x1={10+14} y1={cy1} x2={10+PW-10} y2={cy1} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ppa)"/>
        <line x1={cx1} y1={H-24} x2={cx1} y2={16} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ppa)"/>
        <text x={10+PW-12} y={cy1+13} fontSize="10" fill="#aaa">x₁</text>
        <text x={cx1+4} y={18} fontSize="10" fill="#aaa">x₂</text>

        {/* Concentric guide circles */}
        {[52, 104, 156].map(r => (
          <circle key={r} cx={cx1} cy={cy1} r={r} fill="none" stroke="#f5f5f5" strokeWidth="1"/>
        ))}

        {/* Multiple trajectories from different ICs */}
        {[
          [2.2, 0.5], [-2.0, 0.8], [0.6, 2.3], [-1.4, -1.8]
        ].map(([ix, iy], ti) => {
          let px = ix, py = iy;
          const pts = [];
          for (let i = 0; i < 280; i++) {
            pts.push([cx1 + px * sc, cy1 - py * sc]);
            const dx = -0.3 * px + 1.2 * py;
            const dy = -1.2 * px - 0.3 * py;
            px += dx * 0.04; py += dy * 0.04;
          }
          const col = ['#c0392b','#2E75B6','#e07b00','#9b59b6'][ti];
          return (
            <polyline key={ti} points={pts.map(([x,y])=>`${x},${y}`).join(' ')}
              fill="none" stroke={col} strokeWidth="1.8" opacity="0.85"/>
          );
        })}

        {/* Equilibrium point */}
        <circle cx={cx1} cy={cy1} r={6} fill="#27ae60" stroke="#fff" strokeWidth="2"/>
        <text x={cx1+8} y={cy1-8} fontSize="10" fill="#27ae60" fontWeight="700">equilibrium</text>

        <rect x={16} y={H-60} width={PW-22} height={42} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={22} y={H-46} fontSize="10.5" fill="#27ae60" fontWeight="700">Eigenvalues: λ = −0.3 ± 1.2j</text>
        <text x={22} y={H-32} fontSize="10" fill="#555">Re(λ)&lt;0 → spirals inward → asymptotically stable</text>

        {/* Panel 2: Saddle point */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={cx2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Saddle Point (Real poles, opposite signs)</text>

        <line x1={PW+30} y1={cy2} x2={W-14} y2={cy2} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ppa)"/>
        <line x1={cx2} y1={H-24} x2={cx2} y2={16} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ppa)"/>
        <text x={W-16} y={cy2+13} fontSize="10" fill="#aaa">x₁</text>
        <text x={cx2+4} y={18} fontSize="10" fill="#aaa">x₂</text>

        {/* Saddle trajectories */}
        {saddleLines.map(({ pts, stable }, i) => (
          <polyline key={i} points={pts.map(([x,y])=>`${x},${y}`).join(' ')}
            fill="none" stroke={stable ? '#2E75B6' : '#c0392b'} strokeWidth="1.8" opacity="0.8"/>
        ))}

        {/* Stable / unstable manifold labels */}
        <text x={cx2} y={cy2-170} textAnchor="middle" fontSize="10" fill="#2E75B6" fontStyle="italic">stable manifold (λ₂=−1)</text>
        <text x={cx2+130} y={cy2-8} fontSize="10" fill="#c0392b" fontStyle="italic">unstable manifold (λ₁=+1)</text>

        {/* Saddle equilibrium */}
        <circle cx={cx2} cy={cy2} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>

        <rect x={PW+26} y={H-60} width={PW-22} height={42} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={PW+32} y={H-46} fontSize="10.5" fill="#c0392b" fontWeight="700">Eigenvalues: λ₁=+1, λ₂=−1</text>
        <text x={PW+32} y={H-32} fontSize="10" fill="#555">One positive eigenvalue → unstable in one direction → saddle</text>
      </svg>
      <div style={S.dCaption}>The phase portrait visualises system trajectories for all initial conditions simultaneously. Each curve is a solution x(t) traced through state space. Eigenvalues of A determine the topology: complex conjugate pairs with negative real part → stable spirals; real eigenvalues with mixed signs → saddle points; purely imaginary → centres (sustained oscillation).</div>
    </div>
  );
}

// ── Diagram 4: Eigenvalue Locations & System Behaviour ───────────
function DiagramEigenvalues() {
  const W = 900, H = 320;
  const cards = [
    { re:-2, im:0,  col:'#27ae60', bg:'#f0fff4', bc:'#27ae60', title:'Stable Node',       desc:'Two real, negative eigenvalues\nTrajectories decay along eigenvectors\nNo oscillation — monotone approach', ex:'λ₁=−2, λ₂=−0.5' },
    { re:-1, im:2,  col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', title:'Stable Spiral',     desc:'Complex pair, Re<0\nDamped oscillatory approach\nMost common in physical systems', ex:'λ=−1±2j' },
    { re:0,  im:2,  col:'#e07b00', bg:'#fff9e6', bc:'#e07b00', title:'Centre (Marginal)',  desc:'Purely imaginary eigenvalues\nSustained undamped oscillation\nMarginally stable — not robust', ex:'λ=±2j' },
    { re:1,  im:1.5,col:'#c0392b', bg:'#fff5f5', bc:'#c0392b', title:'Unstable Spiral',   desc:'Complex pair, Re>0\nGrowing oscillation\nSystem diverges exponentially', ex:'λ=+1±1.5j' },
    { re:1,  im:0,  col:'#7B0D0D', bg:'#FEF0F0', bc:'#7B0D0D', title:'Unstable Node',     desc:'Real, positive eigenvalue\nMonotone divergence\nFastest instability type', ex:'λ₁=+1, λ₂=+0.4' },
    { re:-1, im:0,  col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6', title:'Critically Damped', desc:'Repeated real negative eigenvalue\nFastest non-oscillatory decay\nλ repeated → Jordan block possible', ex:'λ₁=λ₂=−1' },
  ];

  const sW = 900, cW = (sW-20)/3, cH = 128;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Eigenvalue Locations and Their System Behaviour</div>
      <svg viewBox={`0 0 ${sW} 280`} style={{ width:'100%', display:'block' }}>
        {/* s-plane sketch */}
        {(() => {
          const px = 680, py = 140, sc = 44;
          return (
            <g>
              <rect x={660} y={10} width={230} height={260} rx={5} fill="#fff" stroke="#f0cece"/>
              <text x={775} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">s-Plane Summary</text>
              {/* Shading */}
              <rect x={664} y={34} width={px-664} height={232} fill="#f0fff4" opacity="0.35"/>
              <rect x={px} y={34} width={886-px} height={232} fill="#FEF0F0" opacity="0.35"/>
              {/* Axes */}
              <line x1={664} y1={py} x2={886} y2={py} stroke="#bbb" strokeWidth="1"/>
              <line x1={px} y1={34} x2={px} y2={266} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3"/>
              <text x={884} y={py+12} fontSize="9" fill="#888">σ</text>
              <text x={px+3} y={38} fontSize="9" fill="#888">jω</text>
              <text x={px-36} y={py+22} fontSize="9" fill="#27ae60">STABLE</text>
              <text x={px+8} y={py+22} fontSize="9" fill="#c0392b">UNSTABLE</text>
              {/* Plot each eigenvalue */}
              {cards.map(({ re, im, col, title }, i) => {
                const ex = px + re*sc, ey = py - im*sc;
                const ey2 = im !== 0 ? py + im*sc : null;
                return (
                  <g key={i}>
                    <line x1={ex-6} y1={ey-6} x2={ex+6} y2={ey+6} stroke={col} strokeWidth="2.2"/>
                    <line x1={ex+6} y1={ey-6} x2={ex-6} y2={ey+6} stroke={col} strokeWidth="2.2"/>
                    {ey2 && <>
                      <line x1={ex-6} y1={ey2-6} x2={ex+6} y2={ey2+6} stroke={col} strokeWidth="2.2"/>
                      <line x1={ex+6} y1={ey2-6} x2={ex-6} y2={ey2+6} stroke={col} strokeWidth="2.2"/>
                    </>}
                  </g>
                );
              })}
            </g>
          );
        })()}

        {/* Cards */}
        {cards.map(({ col, bg, bc, title, desc, ex }, i) => {
          const col2 = i % 3, row = Math.floor(i / 3);
          const x = 8 + col2 * (cW + 3), y = 10 + row * (cH + 6);
          return (
            <g key={i}>
              <rect x={x} y={y} width={cW} height={cH} rx={5} fill={bg} stroke={bc} strokeWidth="1.5"/>
              <rect x={x} y={y} width={cW} height={22} rx={4} fill={bc}/>
              <text x={x+cW/2} y={y+15} textAnchor="middle" fontSize="11.5" fill="#fff" fontWeight="700">{title}</text>
              <text x={x+8} y={y+36} fontSize="10" fill={col} fontFamily="'Courier New',monospace" fontWeight="700">{ex}</text>
              {desc.split('\n').map((line, li) => (
                <text key={li} x={x+8} y={y+52+li*17} fontSize="10" fill="#333">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>The eigenvalues of the A matrix (equivalently, the roots of det(sI − A) = 0) completely determine the qualitative behaviour of the autonomous system ẋ = Ax. Their positions in the complex plane — left half, right half, imaginary axis; real or complex — map one-to-one onto the six fundamental behaviour types shown above.</div>
    </div>
  );
}

// ── Diagram 5: Controllability & Observability ───────────────────
function DiagramCtrlObs() {
  const W = 900, H = 310;
  const PW = (W-30)/2;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Controllability and Observability — The Two Fundamental Structural Properties</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="co1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
          <marker id="co2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Panel 1: Controllability */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Controllability</text>
        <text x={10+PW/2} y={44} textAnchor="middle" fontSize="10" fill="#555">"Can the input steer the state anywhere?"</text>

        {/* Visual: input reaching all states */}
        {(() => {
          const states = [{x:160,y:120,lbl:'x₁'},{x:300,y:80,lbl:'x₂'},{x:360,y:160,lbl:'x₃'},{x:250,y:210,lbl:'x₄'}];
          return <>
            {/* Input box */}
            <rect x={30} y={130} width={70} height={36} rx={4} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
            <text x={65} y={152} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">u(t)</text>
            {states.map(({x,y,lbl}) => (
              <g key={lbl}>
                <circle cx={x} cy={y} r={20} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
                <text x={x} y={y+5} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">{lbl}</text>
                <line x1={100} y1={148} x2={x-20} y2={y} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#co1)" opacity="0.7"/>
              </g>
            ))}
            <text x={10+PW/2} y={255} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">All states reachable ✓</text>
          </>;
        })()}

        <rect x={18} y={260} width={PW-24} height={36} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={26} y={275} fontSize="10.5" fill="#2E75B6" fontWeight="700">Controllability matrix  𝒞 = [B | AB | A²B | … | Aⁿ⁻¹B]</text>
        <text x={26} y={290} fontSize="10" fill="#333">System controllable ⟺ rank(𝒞) = n</text>

        {/* Panel 2: Observability */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Observability</text>
        <text x={PW+20+PW/2} y={44} textAnchor="middle" fontSize="10" fill="#555">"Can the output reveal the full state?"</text>

        {(() => {
          const ox = PW+30;
          const states = [{x:ox+80,y:100,lbl:'x₁'},{x:ox+200,y:80,lbl:'x₂'},{x:ox+260,y:160,lbl:'x₃'},{x:ox+150,y:190,lbl:'x₄'}];
          return <>
            <rect x={ox+300} y={128} width={70} height={36} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
            <text x={ox+335} y={150} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">y(t)</text>
            {states.map(({x,y,lbl}) => (
              <g key={lbl}>
                <circle cx={x} cy={y} r={20} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
                <text x={x} y={y+5} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">{lbl}</text>
                <line x1={x+20} y1={y} x2={ox+300} y2={146} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#co2)" opacity="0.7"/>
              </g>
            ))}
            <text x={PW+20+PW/2} y={255} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">All states inferable from output ✓</text>
          </>;
        })()}

        <rect x={PW+28} y={260} width={PW-24} height={36} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={PW+36} y={275} fontSize="10.5" fill="#27ae60" fontWeight="700">Observability matrix  𝒪 = [C ; CA ; CA² ; … ; CAⁿ⁻¹]</text>
        <text x={PW+36} y={290} fontSize="10" fill="#333">System observable ⟺ rank(𝒪) = n</text>
      </svg>
      <div style={S.dCaption}>Controllability asks: starting from any initial state, can the input u(t) drive the system to any desired state in finite time? Observability asks: given only the output y(t) over some interval, can the initial state x(0) be uniquely determined? Both are tested by the rank of their respective matrices. A system must be controllable to place poles via state feedback, and observable to design a state estimator (observer).</div>
    </div>
  );
}

// ── Diagram 6: State Feedback & Pole Placement ───────────────────
function DiagramStateFeedback() {
  const W = 900, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>State Feedback, Pole Placement, and the Linear Quadratic Regulator (LQR)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="sf1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="sf2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
        </defs>

        {/* Reference input */}
        <text x={10} y={125} fontSize="11" fill="#555">r(t)</text>
        <line x1={34} y1={121} x2={68} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>

        {/* Summing junction */}
        <circle cx={82} cy={121} r={13} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
        <text x={82} y={126} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">Σ</text>
        <text x={76} y={112} fontSize="10" fill="#2E75B6">+</text>
        <text x={78} y={138} fontSize="10" fill="#c0392b">−</text>

        {/* State feedback gain K block */}
        <line x1={95} y1={121} x2={128} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>
        <rect x={128} y={101} width={90} height={40} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={173} y={124} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">−K</text>
        <text x={173} y={137} textAnchor="middle" fontSize="9" fill="#c0392b">gain matrix (1×n)</text>

        {/* Plant B */}
        <line x1={218} y1={121} x2={258} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>
        <circle cx={272} cy={121} r={13} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
        <text x={272} y={126} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">Σ</text>

        <line x1={285} y1={121} x2={318} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>
        <rect x={318} y={101} width={70} height={40} rx={4} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
        <text x={353} y={124} textAnchor="middle" fontSize="14" fill="#2E75B6" fontWeight="700" fontFamily="'Courier New',monospace">B</text>

        {/* Integrator */}
        <line x1={388} y1={121} x2={420} y2={121} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#sf2)"/>
        <text x={404} y={115} fontSize="9" fill="#555">ẋ</text>
        <rect x={420} y={101} width={80} height={40} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={460} y={123} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontFamily="'Courier New',monospace" fontWeight="700">1/s</text>
        <text x={460} y={137} textAnchor="middle" fontSize="10" fill="#c0392b">integrator</text>

        {/* x pick-off */}
        <line x1={500} y1={121} x2={560} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>
        <circle cx={560} cy={121} r={4} fill="#c0392b"/>
        <text x={528} y={115} fontSize="9" fill="#555">x(t)</text>

        {/* C output */}
        <line x1={560} y1={121} x2={594} y2={121} stroke="#c0392b" strokeWidth="2" markerEnd="url(#sf1)"/>
        <rect x={594} y={101} width={70} height={40} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
        <text x={629} y={124} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700" fontFamily="'Courier New',monospace">C</text>
        <line x1={664} y1={121} x2={700} y2={121} stroke="#27ae60" strokeWidth="2" markerEnd="url(#sf1)"/>
        <text x={706} y={125} fontSize="11" fill="#555">y(t)</text>

        {/* A feedback */}
        <rect x={364} y={186} width={70} height={36} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
        <text x={399} y={208} textAnchor="middle" fontSize="14" fill="#c0392b" fontWeight="700" fontFamily="'Courier New',monospace">A</text>
        <line x1={560} y1={121} x2={560} y2={204} stroke="#c0392b" strokeWidth="1.5"/>
        <line x1={560} y1={204} x2={434} y2={204} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#sf1)"/>
        <line x1={364} y1={204} x2={272} y2={204} stroke="#c0392b" strokeWidth="1.5"/>
        <line x1={272} y1={204} x2={272} y2={136} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#sf1)"/>

        {/* State feedback path -Kx */}
        <line x1={560} y1={125} x2={560} y2={250} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3"/>
        <line x1={560} y1={250} x2={82} y2={250} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3"/>
        <line x1={82} y1={250} x2={82} y2={136} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" markerEnd="url(#sf1)"/>
        <text x={320} y={266} textAnchor="middle" fontSize="10" fill="#c0392b" fontStyle="italic">state feedback: u = r − Kx  (full state measurement required)</text>

        {/* Right panel */}
        <rect x={730} y={10} width={158} height={H-18} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={809} y={28} textAnchor="middle" fontSize="11.5" fill="#7B0D0D" fontWeight="700">Design Methods</text>
        {[
          { y:36, col:'#c0392b', bg:'#fff5f5', bc:'#c0392b', t:['Pole Placement','Choose desired poles p*','Solve: det(sI−A+BK)=Π(s−p*)','Ackermann: K=eₙᵀ𝒞⁻¹Φ(A)'] },
          { y:140, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', t:['LQR (Optimal)','Minimise J=∫(xᵀQx+uᵀRu)dt','Solve Riccati: AᵀP+PA−PBR⁻¹BᵀP+Q=0','K = R⁻¹BᵀP  (optimal gain)'] },
          { y:244, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60', t:['Closed-loop A−BK','Eigenvalues of A−BK are the','closed-loop poles; choose them','in LHP for desired response'] },
        ].map(({ y, col, bg, bc, t }) => (
          <g key={y}>
            <rect x={736} y={y} width={146} height={t.length*16+18} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {t.map((line, i) => <text key={i} x={742} y={y+14+i*16} fontSize={i===0?'10.5':'9.5'} fill={i===0?col:'#333'} fontWeight={i===0?'700':'400'}>{line}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>State feedback u = r − Kx uses full knowledge of the state vector to place the closed-loop poles of A − BK at any desired locations (provided the system is controllable). Pole placement is direct but requires choosing poles by intuition. The LQR method optimally trades off state deviation (weighted by Q) against control effort (weighted by R) by solving the Algebraic Riccati Equation.</div>
    </div>
  );
}

// ── Diagram 7: Luenberger Observer ───────────────────────────────
function DiagramObserver() {
  const W = 900, H = 295;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Luenberger Observer (State Estimator) — Reconstructing x(t) from y(t)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ob1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="ob2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#9b59b6"/>
          </marker>
          <marker id="ob3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* ── True plant (top row) ── */}
        <text x={10} y={55} fontSize="10" fill="#777" fontStyle="italic">TRUE PLANT</text>
        <text x={14} y={100} fontSize="10" fill="#555">u(t)</text>
        <line x1={38} y1={96} x2={72} y2={96} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ob1)"/>
        <rect x={72} y={76} width={65} height={36} rx={4} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
        <text x={104} y={97} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">B</text>
        <circle cx={166} cy={96} r={12} fill="#fff" stroke="#c0392b" strokeWidth="2"/>
        <text x={166} y={101} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">Σ</text>
        <line x1={137} y1={96} x2={152} y2={96} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#ob1)"/>
        <line x1={178} y1={96} x2={208} y2={96} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ob1)"/>
        <rect x={208} y={76} width={72} height={36} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={244} y={96} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontFamily="'Courier New',monospace">1/s</text>
        <line x1={280} y1={96} x2={330} y2={96} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ob1)"/>
        <circle cx={336} cy={96} r={4} fill="#c0392b"/>
        <text x={305} y={90} fontSize="9" fill="#555">x(t)</text>
        <rect x={348} y={76} width={60} height={36} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
        <text x={378} y={97} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">C</text>
        <line x1={408} y1={96} x2={460} y2={96} stroke="#27ae60" strokeWidth="2" markerEnd="url(#ob3)"/>
        <text x={466} y={100} fontSize="10" fill="#555">y(t)</text>
        {/* A feedback true plant */}
        <line x1={336} y1={96} x2={336} y2={130} stroke="#c0392b" strokeWidth="1.5"/>
        <rect x={246} y={130} width={60} height={28} rx={3} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={276} y={148} textAnchor="middle" fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">A</text>
        <line x1={336} y1={130} x2={306} y2={130} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#ob1)"/>
        <line x1={246} y1={144} x2={166} y2={144} stroke="#c0392b" strokeWidth="1.5"/>
        <line x1={166} y1={144} x2={166} y2={110} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#ob1)"/>

        {/* Divider */}
        <line x1={10} y1={168} x2={640} y2={168} stroke="#f0cece" strokeWidth="1.5" strokeDasharray="6,4"/>
        <text x={10} y={183} fontSize="10" fill="#9b59b6" fontStyle="italic">OBSERVER MODEL  x̂˙ = Ax̂ + Bu + L(y−Cx̂)</text>

        {/* ── Observer (bottom row) ── */}
        <line x1={38} y1={220} x2={72} y2={220} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#ob2)"/>
        <rect x={72} y={200} width={65} height={36} rx={4} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={104} y={221} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">B</text>
        <circle cx={166} cy={220} r={12} fill="#fff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={166} y={225} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">Σ</text>
        <line x1={137} y1={220} x2={152} y2={220} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#ob2)"/>
        <line x1={178} y1={220} x2={208} y2={220} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#ob2)"/>
        <rect x={208} y={200} width={72} height={36} rx={4} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={244} y={220} textAnchor="middle" fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">1/s</text>
        <line x1={280} y1={220} x2={328} y2={220} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#ob2)"/>
        <circle cx={334} cy={220} r={4} fill="#9b59b6"/>
        <text x={296} y={214} fontSize="9" fill="#9b59b6">x̂(t)</text>

        {/* Observer correction: L(y - Cx̂) */}
        <rect x={346} y={200} width={60} height={36} rx={4} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={376} y={221} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">C</text>
        <line x1={406} y1={220} x2={436} y2={220} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#ob2)"/>
        <circle cx={450} cy={220} r={12} fill="#fff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={450} y={225} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">Σ</text>
        <text x={444} y={212} fontSize="10" fill="#c0392b">+</text>
        <text x={462} y={212} fontSize="10" fill="#9b59b6">−</text>
        {/* y feeds into the summing junction */}
        <line x1={466} y1={96} x2={530} y2={96} stroke="#27ae60" strokeWidth="1.5"/>
        <line x1={530} y1={96} x2={530} y2={210} stroke="#27ae60" strokeWidth="1.5"/>
        <line x1={530} y1={220} x2={462} y2={220} stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#ob3)"/>
        {/* Innovation → L gain */}
        <line x1={450} y1={232} x2={450} y2={258} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ob1)"/>
        <rect x={416} y={258} width={68} height={28} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={450} y={276} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700" fontFamily="'Courier New',monospace">L</text>
        <line x1={416} y1={272} x2={166} y2={272} stroke="#c0392b" strokeWidth="2"/>
        <line x1={166} y1={272} x2={166} y2={234} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ob1)"/>
        <text x={290} y={268} textAnchor="middle" fontSize="9" fill="#c0392b" fontStyle="italic">innovation correction: L·(y−ŷ)</text>

        {/* A feedback observer */}
        <line x1={334} y1={220} x2={334} y2={254} stroke="#9b59b6" strokeWidth="1.5"/>
        <rect x={248} y={254} width={60} height={26} rx={3} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="1.5"/>
        <text x={278} y={271} textAnchor="middle" fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">A</text>
        <line x1={334} y1={254} x2={308} y2={254} stroke="#9b59b6" strokeWidth="1.5" markerEnd="url(#ob2)"/>
        <line x1={248} y1={267} x2={166} y2={267} stroke="#9b59b6" strokeWidth="1.5"/>

        {/* Right panel */}
        <rect x={650} y={10} width={238} height={H-18} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={769} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Observer Design</text>
        {[
          { y:36, col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6', t:['Observer equation','x̂˙ = Ax̂ + Bu + L(y−Cx̂)','= (A−LC)x̂ + Bu + Ly'] },
          { y:104, col:'#c0392b', bg:'#fff5f5', bc:'#c0392b', t:['Error dynamics','ė = (A−LC)e,  e = x−x̂','Choose L: eig(A−LC) stable'] },
          { y:172, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', t:['Pole placement (dual)','Observer poles typically 2–5×','faster than controller poles'] },
          { y:222, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60', t:['Kalman Filter (LQE)','Optimal L for stochastic systems','L = PCᵀV⁻¹  (P from Riccati)','Trades process vs. sensor noise'] },
        ].map(({ y, col, bg, bc, t }) => (
          <g key={y}>
            <rect x={656} y={y} width={226} height={t.length*16+18} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {t.map((line, i) => <text key={i} x={662} y={y+14+i*16} fontSize={i===0?'10.5':'9.5'} fill={i===0?col:'#333'} fontWeight={i===0?'700':'400'} fontFamily={i>0&&i<3?'Courier New,monospace':'inherit'}>{line}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>When full state measurement is unavailable, a Luenberger observer runs a copy of the plant model in parallel, correcting its estimate x̂ by the innovation y − Cx̂ — the discrepancy between measured and predicted output — scaled by gain L. The error e = x − x̂ evolves according to ė = (A − LC)e; placing the eigenvalues of A − LC in the left half-plane ensures the error decays to zero. The Kalman filter is the optimal observer for systems with Gaussian noise.</div>
    </div>
  );
}

// ── Diagram 8: Discretisation & Similarity Transforms ────────────
function DiagramDiscreteSimilarity() {
  const W = 900, H = 310;
  const PW = (W-30)/2;

  // Plot: continuous vs ZOH discrete step response
  const N = 80, T = 0.25; // sampling period
  const tVals = Array.from({length:200},(_,i)=>i/200*8);
  const contY = tVals.map(t => 1 - Math.exp(-t));
  const zkPts = [];
  let zk = 0;
  for (let k = 0; k*T <= 8; k++) {
    const tkf = Math.min((k+1)*T, 8);
    zk = 1 - Math.exp(-k*T); // discrete state
    zkPts.push([k*T, zk]);
    zkPts.push([tkf, zk]);
  }

  const ox = 16, oy = 240, ow = PW-30, oh = 190;
  const mapX = t => ox + (t/8)*ow;
  const mapY = v => oy - v*oh;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Discretisation (ZOH) and Similarity Transformations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ds1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Discrete vs continuous */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">ZOH Discretisation — Continuous vs. Discrete Step Response</text>

        {/* Axes */}
        <line x1={ox} y1={oy+8} x2={ox+ow+16} y2={oy+8} stroke="#888" strokeWidth="1.5" markerEnd="url(#ds1)"/>
        <line x1={ox} y1={oy+8} x2={ox} y2={oy-oh-14} stroke="#888" strokeWidth="1.5" markerEnd="url(#ds1)"/>
        <text x={ox+ow+20} y={oy+12} fontSize="10" fill="#555">t</text>
        <text x={ox-6} y={oy-oh-16} fontSize="10" fill="#555">y</text>

        {/* Continuous curve */}
        <polyline points={tVals.map((t,i)=>`${mapX(t)},${mapY(contY[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* ZOH staircase */}
        <polyline points={zkPts.map(([t,v])=>`${mapX(t)},${mapY(v)}`).join(' ')}
          fill="none" stroke="#2E75B6" strokeWidth="2" strokeDasharray="none"/>

        {/* Sample dots */}
        {Array.from({length:Math.floor(8/T)+1},(_,k)=>k*T).map(t=>(
          <circle key={t} cx={mapX(t)} cy={mapY(1-Math.exp(-t))} r={3.5} fill="#2E75B6"/>
        ))}

        {/* Grid */}
        {[0,0.5,1].map(v=>(
          <g key={v}>
            <line x1={ox} y1={mapY(v)} x2={ox+ow} y2={mapY(v)} stroke="#f5f5f5" strokeWidth="1"/>
            <text x={ox-4} y={mapY(v)+4} textAnchor="end" fontSize="9" fill="#aaa">{v}</text>
          </g>
        ))}

        <text x={ox+16} y={mapY(0.5)-8} fontSize="10" fill="#c0392b">Continuous y(t)=1−e⁻ᵗ</text>
        <text x={ox+16} y={mapY(0.2)+20} fontSize="10" fill="#2E75B6">ZOH discrete (T=0.25 s)</text>

        <rect x={16} y={252} width={PW-22} height={44} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={22} y={268} fontSize="10.5" fill="#2E75B6" fontWeight="700">ZOH formulae:  Φ = eᴬᵀ,  Γ = A⁻¹(eᴬᵀ−I)B</text>
        <text x={22} y={284} fontSize="10" fill="#333">x[k+1] = Φ·x[k] + Γ·u[k]   (exact if u is piecewise-constant)</text>
        <text x={22} y={295} fontSize="10" fill="#333">Approximate: Φ≈I+AT, Γ≈BT  (valid when T ≪ smallest time constant)</text>

        {/* Panel 2: Similarity transform */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Similarity Transformations — Canonical Forms</text>

        {/* Transform diagram */}
        {(() => {
          const forms = [
            { x:PW+36,  y:50,  w:130, h:52, bg:'#FEF0F0', bc:'#c0392b', t:'Original (A,B,C,D)', sub:'Any basis\nAll equivalent' },
            { x:PW+36,  y:140, w:130, h:52, bg:'#eaf3ff', bc:'#2E75B6', t:'Controllable Canon.', sub:'A: companion form\n1st row drives control' },
            { x:PW+196, y:140, w:130, h:52, bg:'#f0fff4', bc:'#27ae60', t:'Observable Canon.', sub:'A: companion (transposed)\nC = [1 0 … 0]' },
            { x:PW+36,  y:230, w:130, h:52, bg:'#fff9e6', bc:'#e07b00', t:'Modal (Diagonal)', sub:'A = diag(λ₁,λ₂,…,λₙ)\nDecoupled modes' },
            { x:PW+196, y:230, w:130, h:52, bg:'#f8f0ff', bc:'#9b59b6', t:'Jordan Normal Form', sub:'A = Jordan blocks\nFor repeated eigenvalues' },
          ];
          const arrows = [
            [PW+36+65, 102, PW+36+65,  140],
            [PW+36+65, 102, PW+196+65, 140],
            [PW+36+65, 192, PW+36+65,  230],
            [PW+36+65, 192, PW+196+65, 230],
          ];
          return (
            <g>
              {forms.map(({ x, y, w, h, bg, bc, t, sub }) => (
                <g key={t}>
                  <rect x={x} y={y} width={w} height={h} rx={4} fill={bg} stroke={bc} strokeWidth="1.5"/>
                  <text x={x+w/2} y={y+17} textAnchor="middle" fontSize="10.5" fill={bc} fontWeight="700">{t}</text>
                  {sub.split('\n').map((line,i)=>(
                    <text key={i} x={x+6} y={y+31+i*14} fontSize="9.5" fill="#555">{line}</text>
                  ))}
                </g>
              ))}
              {arrows.map(([x1,y1,x2,y2],i)=>(
                <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#aaa" strokeWidth="1.5"
                  strokeDasharray="4,3" markerEnd="url(#ds1)"/>
              ))}
              <text x={PW+36+64} y={135} textAnchor="middle" fontSize="9" fill="#888">T: x=Tz̃</text>

              {/* Transform formula */}
              <rect x={PW+26} y={285} width={PW-36} height={18} rx={2} fill="#FEF0F0"/>
              <text x={PW+30} y={298} fontSize="10" fill="#7B0D0D" fontWeight="700">z = T⁻¹x  →  Ã=T⁻¹AT,  B̃=T⁻¹B,  C̃=CT,  D̃=D  (TF unchanged)</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>Zero-order hold (ZOH) discretisation converts a continuous state-space model to an equivalent discrete-time model that is exact when the input is held constant between samples. Similarity transformations x = Tz̃ change the coordinate basis without altering the input-output behaviour: eigenvalues, transfer function, and controllability/observability are all preserved. Canonical forms simplify analysis and controller design.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function StateSpace() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>State Space Representation</h1>
      <p style={S.p}>
        State space representation is the modern, generalised framework for modelling dynamic systems. Rather than describing a system by a single transfer function relating input to output, the state-space approach tracks an internal state vector x(t) that captures all the information needed to predict future behaviour. Two matrix equations — the state equation and the output equation — replace the scalar ODE of transfer-function methods. This approach handles multi-input multi-output (MIMO) systems, nonlinear systems (via linearisation), time-varying parameters, and initial conditions on equal footing, making it the foundation of modern control theory, estimation, and simulation.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "State vector x ∈ ℝⁿ: the minimal set of variables that, together with future inputs, completely determines future outputs",
        "State equation: ẋ = Ax + Bu  — describes how inputs and current state drive the rate of change of state",
        "Output equation: y = Cx + Du  — maps the internal state to the measurable outputs",
        "Eigenvalues of A determine stability and natural response modes — identical to transfer function poles",
        "Controllability: can input u steer x to any desired value? Test: rank[B | AB | … | Aⁿ⁻¹B] = n",
        "Observability: can output y reveal the full state x? Test: rank[C; CA; …; CAⁿ⁻¹] = n",
        "State feedback u = −Kx places closed-loop poles anywhere (if controllable) — enables arbitrary transient shaping",
        "Luenberger observer / Kalman filter reconstructs unmeasured states from outputs",
        "Separation principle: design controller and observer independently — they do not interact in closed loop",
        "Discretisation converts continuous (A, B, C, D) to exact discrete-time equivalent via matrix exponential eᴬᵀ",
      ]} />

      <h2 style={S.h2}>The State-Space Equations</h2>
      <p style={S.p}>
        The state-space model expresses an nth-order system as n coupled first-order differential equations. Every higher-order ODE can be rewritten in state-space form by introducing the derivatives as new state variables. The four matrices A, B, C, D encode, respectively, the internal dynamics, input coupling, output sensing, and direct feedthrough.
      </p>
      <DiagramSSAnatomy />
      <Table2 rows={[
        ["State equation", "ẋ(t) = A·x(t) + B·u(t)\nA is n×n, B is n×p\nDescribes the rate-of-change of every state variable\nEach row: how one state derivative depends on all states and inputs"],
        ["Output equation", "y(t) = C·x(t) + D·u(t)\nC is q×n, D is q×p\nMaps internal states to the q measured/observed outputs\nD = 0 for most physical plants (strictly proper TF)"],
        ["State x(t)", "x ∈ ℝⁿ: the minimal internal variable set\nExamples: position & velocity; charge & flux; concentration\nNot unique — any invertible coordinate change gives an equivalent model"],
        ["Converting nth-order ODE", "y⁽ⁿ⁾ + aₙ₋₁y⁽ⁿ⁻¹⁾ + … + a₀y = b₀u\nPhase-variable form: x₁=y, x₂=ẏ, …, xₙ=y⁽ⁿ⁻¹⁾\nA = companion matrix; B = [0…0 1]ᵀ; C = [b₀ b₁… bₙ₋₁]"],
        ["Solution — state transition", "x(t) = eᴬᵗ x(0) + ∫₀ᵗ eᴬ⁽ᵗ⁻τ⁾ B u(τ) dτ\neᴬᵗ = state transition matrix (matrix exponential)\nFirst term: free (unforced) response; second: forced response"],
        ["Matrix exponential eᴬᵗ", "eᴬᵗ = I + At + A²t²/2! + … (infinite series)\nFor diagonal A: eᴬᵗ = diag(eλ₁ᵗ, eλ₂ᵗ, …)\nComputed in practice via Cayley-Hamilton or numerical methods"],
        ["Transfer function from SS", "G(s) = C(sI−A)⁻¹B + D\nNumerator zeros come from C, B interaction\nDenominator = det(sI−A) = characteristic polynomial"],
        ["Linearisation", "Nonlinear ẋ = f(x,u): linearise at equilibrium (x*, u*)\nA = ∂f/∂x|*, B = ∂f/∂u|*  (Jacobian matrices)\nValid for small perturbations Δx, Δu around the operating point"],
      ]} />

      <h2 style={S.h2}>Block Diagram and Signal Flow</h2>
      <p style={S.p}>
        The block diagram of a state-space system reveals how the four matrices act as signal-processing operations in a feedback loop. The integrator 1/s is the central element — it is the state storage device, equivalent to a stock in system dynamics terms. The A matrix closes an internal feedback loop that creates the system's autonomous dynamics.
      </p>
      <DiagramSSBlockDiagram />
      <Table2 rows={[
        ["Internal feedback loop", "A feeds state x back to the derivative ẋ\nThis self-referential loop is the source of all dynamic behaviour\nWithout A: system is a static map from u to x to y with no memory"],
        ["Role of B", "Columns of B = how each input component enters the state equations\nIf a column of B is zero, that input cannot directly affect any state derivative\nRank(B) determines how many independent input directions are available"],
        ["Role of C", "Rows of C = which linear combinations of states are measured\nC = I (identity) means all states observed directly — full state feedback possible\nC with fewer rows → partial observation → observer needed"],
        ["Role of D", "Instantaneous feed-forward from u to y\nPhysical meaning: ideal differentiators or infinite-bandwidth paths\nD ≠ 0 implies system is not strictly proper: |G(jω)| → constant as ω→∞"],
        ["Equivalent forms", "Multiple (A,B,C,D) quadruples can produce the same input-output TF\nDifference: unobservable or uncontrollable hidden modes\nMinimal realisation: smallest n with no hidden modes — unique up to similarity transform"],
      ]} />

      <h2 style={S.h2}>Phase Portrait and State Trajectories</h2>
      <p style={S.p}>
        The phase portrait is the geometric picture of a system's dynamics. Every point in state space has a unique velocity vector ẋ = Ax + Bu; the collection of all trajectories paints a complete picture of the system's possible evolutions. The topology of the portrait — spirals, nodes, saddle points — is determined entirely by the eigenvalues of A.
      </p>
      <DiagramPhasePortrait />
      <Table2 rows={[
        ["Phase portrait", "Plot of state trajectories {x(t) : t≥0} in the n-dimensional state space\nEach curve corresponds to one initial condition x(0)\nArrows indicate direction of increasing time"],
        ["Equilibrium point", "x* where ẋ = Ax* + Bu* = 0\nFor autonomous system (u=0): x* = 0 if A is invertible\nFor system with input: x* = −A⁻¹Bu*"],
        ["Stable node", "All eigenvalues real, negative: trajectories decay along eigenvectors\nFastest mode dominates far from origin; slowest mode dominates near it\nNo oscillation — appropriate when overshoot is unacceptable"],
        ["Stable spiral", "Complex eigenvalues λ = σ ± jω, σ < 0\nTrajectories rotate and spiral into origin\nRotation rate = ωd; decay rate = |σ|; most physical systems"],
        ["Centre (marginal)", "Purely imaginary λ = ±jω: closed ellipses forever\nNo energy dissipation model — structurally unstable\nSmall perturbation in A turns it into a spiral (stable or unstable)"],
        ["Saddle point", "Real eigenvalues of mixed sign (λ₁ < 0 < λ₂)\nStable manifold: trajectories approaching along eigenvector of λ₁\nUnstable manifold: trajectories escaping along eigenvector of λ₂\nAll trajectories except on stable manifold eventually diverge"],
        ["Lyapunov stability", "Global stability: find V(x)>0 with V̇(x)<0 everywhere (energy-like)\nLyapunov equation: AᵀP + PA = −Q  (P>0 iff A is stable)\nConverse: A stable ⟺ Lyapunov equation has a unique positive-definite solution P"],
      ]} />

      <h2 style={S.h2}>Eigenvalues and System Behaviour</h2>
      <p style={S.p}>
        The eigenvalues of A — the roots of det(sI − A) = 0 — are the poles of the system's transfer function and completely govern the nature of the transient response of the autonomous system. Their position in the complex plane is the key diagnostic for both stability and response character.
      </p>
      <DiagramEigenvalues />
      <Table2 rows={[
        ["Characteristic polynomial", "p(s) = det(sI−A) = sⁿ + aₙ₋₁sⁿ⁻¹ + … + a₀\nRoots λ₁,…,λₙ are the eigenvalues of A\nIdentical to denominator of G(s) = C(sI−A)⁻¹B+D"],
        ["Trace and determinant", "trace(A) = Σλᵢ  (sum of diagonal elements)\ndet(A) = Πλᵢ  (product of all eigenvalues)\nQuick stability check: if trace>0 or det<0 → unstable"],
        ["Eigenvectors", "Av = λv → v is the direction of pure exponential motion eλᵗv\nMatrix of eigenvectors V diagonalises A: V⁻¹AV = Λ (diagonal)\nComplex conjugate pairs of eigenvalues → pairs of conjugate eigenvectors"],
        ["Spectral decomposition", "For diagonalisable A: eᴬᵗ = Σᵢ eλᵢᵗ vᵢwᵢᵀ\nvᵢ = right eigenvectors; wᵢ = left eigenvectors (rows of V⁻¹)\nEach mode eλᵢᵗ is independently observable and steerable"],
        ["Cayley-Hamilton theorem", "Every matrix satisfies its own characteristic polynomial: p(A) = 0\nAllows Aᵏ for k≥n to be expressed as linear combination of I,A,…,Aⁿ⁻¹\nUsed to compute eᴬᵀ efficiently"],
        ["Stability: Routh-Hurwitz", "All coefficients of p(s) must be positive (necessary but not sufficient)\nRouth array: all elements in left column positive → all eigenvalues in LHP\nAlgebraic — no need to compute eigenvalues explicitly"],
        ["PBH test", "Popov-Belevitch-Hautus: rank[λI−A, B] = n for all eigenvalues λ\nTests whether eigenvalue λ is controllable (reachable via B)\nDual: rank[λI−A; C] = n tests observability of each mode"],
      ]} />

      <h2 style={S.h2}>Controllability and Observability</h2>
      <p style={S.p}>
        Controllability and observability are the two fundamental structural properties of a state-space model. Controllability determines whether a controller can influence all internal modes; observability determines whether an observer can infer all internal states from measurements. They are dual to one another: the observability of (A, C) is identical to the controllability of (Aᵀ, Cᵀ).
      </p>
      <DiagramCtrlObs />
      <Table2 rows={[
        ["Controllability matrix 𝒞", "𝒞 = [B | AB | A²B | … | Aⁿ⁻¹B]  (n×np matrix)\nrank(𝒞) = n → fully controllable\nrank(𝒞) < n → some modes unreachable by input u"],
        ["Observability matrix 𝒪", "𝒪 = [C; CA; CA²; …; CAⁿ⁻¹]  (nq×n matrix)\nrank(𝒪) = n → fully observable\nrank(𝒪) < n → some modes invisible in output y"],
        ["Physical interpretation (C)", "Controllable: the energy from input u can be directed into every mode\nUncontrollable mode: an internal oscillation the input cannot excite or damp\nExample: symmetric pendulum pair where one mode cancels at the input point"],
        ["Physical interpretation (O)", "Observable: every mode leaves a trace in the output\nUnobservable mode: internal dynamics invisible to the sensor\nExample: two identical resonators summed at output — difference mode hidden"],
        ["Duality principle", "System (A,B,C) controllable ⟺ dual system (Aᵀ,Cᵀ,Bᵀ) observable\nPole placement for controllers ↔ pole placement for observers\nLQR ↔ Kalman filter: same Riccati equation structure"],
        ["Gramians", "Controllability Gramian: Wc = ∫eᴬᵗBBᵀeᴬᵀᵗdt  (solves AWc+WcAᵀ+BBᵀ=0)\nObservability Gramian: Wo = ∫eᴬᵀᵗCᵀCeᴬᵗdt  (solves AᵀWo+WoA+CᵀC=0)\nEigenvalues of WcWo = Hankel singular values → model order reduction"],
        ["Minimum realisation", "Kalman decomposition separates system into 4 parts:\ncontrollable & observable; controllable & unobservable;\nuncontrollable & observable; uncontrollable & unobservable\nMinimal: keep only the controllable AND observable subspace"],
        ["Staircase algorithm", "Numerically robust test for controllability/observability\nIteratively builds an orthogonal basis for the controllable subspace\nUsed in practical software (LAPACK, MATLAB/Python Control)"],
      ]} />

      <h2 style={S.h2}>State Feedback and Pole Placement</h2>
      <p style={S.p}>
        State feedback u = r − Kx uses the full state vector to compute the control input. By choosing the gain matrix K, the designer places the eigenvalues of the closed-loop matrix A − BK at any desired locations in the complex plane — provided the system is controllable. This is the state-space analogue of transfer-function pole placement, but extends naturally to MIMO systems.
      </p>
      <DiagramStateFeedback />
      <Table2 rows={[
        ["Closed-loop matrix", "With u = −Kx (regulator, r=0):\nẋ = (A−BK)x\nChoose K so that eig(A−BK) = desired poles {p₁, p₂, …, pₙ}"],
        ["Ackermann's formula", "K = eₙᵀ 𝒞⁻¹ Φ_d(A)\neₙ = [0…0 1] (last standard basis vector)\nΦ_d(s) = ∏(s−pᵢ) — desired characteristic polynomial\nEvaluate polynomial Φ_d at matrix A via Cayley-Hamilton"],
        ["Pole placement guidelines", "All real: fast non-oscillatory regulation\nComplex pairs: faster with controlled oscillation\nReal part (σ) determines decay speed: tₛ ≈ 4/σ\nAvoid placing poles too far left: large K → large control effort → saturation"],
        ["LQR — optimal state feedback", "Minimise J = ∫₀^∞ (xᵀQx + uᵀRu) dt\nQ≥0 penalises state deviation; R>0 penalises control effort\nSolution: K = R⁻¹BᵀP where P satisfies Algebraic Riccati Equation (ARE)\nAᵀP + PA − PBR⁻¹BᵀP + Q = 0"],
        ["Algebraic Riccati Equation", "AᵀP + PA − PBR⁻¹BᵀP + Q = 0\nUnique stabilising solution P>0 exists iff (A,B) controllable and (A,Q½) observable\nLQR guarantees: GM ≥ 6 dB, PM ≥ 60° (for single-input systems)"],
        ["Reference tracking", "u = −Kx + Nr  where N = −(C(A−BK)⁻¹B)⁻¹ (steady-state gain)\nPre-compensator N scales r so DC output equals r in steady state\nAlternative: add integrator in loop for zero steady-state error"],
        ["Control effort trade-off", "Large Q/R ratio → aggressive control → fast response, large inputs\nSmall Q/R ratio → gentle control → slow response, small inputs\nQ = CᵀC (LQG default): penalises output deviation, not all states"],
      ]} />

      <h2 style={S.h2}>State Estimation — The Luenberger Observer</h2>
      <p style={S.p}>
        Full state feedback requires knowledge of all state variables, but in practice only the outputs y are measured. A state observer (state estimator) runs a parallel model of the system, continuously correcting its state estimate x̂ using the discrepancy between the predicted output Cx̂ and the actual measurement y. The Kalman filter is the optimal observer when process and measurement noise are present.
      </p>
      <DiagramObserver />
      <Table2 rows={[
        ["Observer equation", "x̂˙ = Ax̂ + Bu + L(y − Cx̂)\n= (A−LC)x̂ + Bu + Ly\nL is the n×q observer gain matrix — chosen to place eig(A−LC)"],
        ["Error dynamics", "Define estimation error e = x − x̂\nė = ẋ − x̂˙ = Ae + (BuActual − BuModel) + LC·e\n= (A−LC)e  (if same u used in plant and observer)\nError decays iff all eig(A−LC) have negative real part"],
        ["Observer pole placement", "By duality: if (A,C) observable, can choose any eig(A−LC)\nCompute by transposing: same Ackermann/ARE on (Aᵀ,Cᵀ)\nObserver poles typically 2–5× faster than controller poles (faster estimation than control)"],
        ["Separation principle", "With combined state feedback + observer: u = −Kx̂\nClosed-loop eigenvalues = eig(A−BK) ∪ eig(A−LC)\nThe two designs are fully independent — separation principle\nHolds for LTI systems; fails for nonlinear systems in general"],
        ["Kalman filter (LQE)", "Optimal observer when process noise w ~ N(0,Q) and measurement noise v ~ N(0,R)\nx̂˙ = Ax̂ + Bu + L(y−Cx̂);  L = PCᵀR⁻¹\nP satisfies: AP + PAᵀ − PCᵀR⁻¹CP + Q = 0  (dual of LQR Riccati)\nMinimises E[eᵀe] — optimal in mean-square sense"],
        ["LQG controller", "LQR (controller) + Kalman filter (observer) = LQG\nOptimal output-feedback controller under Gaussian noise\nLQG/LTR: loop-transfer recovery to restore LQR margins at plant input"],
        ["Extended Kalman Filter (EKF)", "Nonlinear observer: linearise f(x,u) and h(x,u) at each time step\nx̂˙ = f(x̂,u) + L(y−h(x̂,u))\nNot guaranteed optimal but widely used in robotics, navigation, signal processing"],
        ["Reduced-order observer", "If some states are directly measured (y includes some xᵢ directly)\nDesign observer only for the unmeasured states\nOrder = n − rank(C): reduces computational cost and noise amplification"],
      ]} />

      <h2 style={S.h2}>Discretisation and Similarity Transforms</h2>
      <p style={S.p}>
        Most modern controllers are implemented digitally, requiring conversion from continuous-time to discrete-time. Zero-order hold (ZOH) discretisation produces an exact discrete model when the input is piecewise-constant between samples. Similarity transformations reveal that infinitely many (A,B,C,D) quadruples encode the same dynamics — canonical forms exploit this freedom to simplify analysis.
      </p>
      <DiagramDiscreteSimilarity />
      <Table2 rows={[
        ["ZOH discretisation", "Φ = eᴬᵀ  (discrete state matrix)\nΓ = A⁻¹(eᴬᵀ−I)B  (discrete input matrix; use ∫₀ᵀeᴬσdσ B if A singular)\nExact when u[k] = const over [kT, (k+1)T)\nEigenvalues map: λ_d = eλ_c·T  (LHP → inside unit circle)"],
        ["Stability: discrete domain", "Continuous: eigenvalues in LHP (Re<0)\nDiscrete: eigenvalues inside unit circle |z|<1\nMapping λ_d = eλT: stable region changes but stability is preserved"],
        ["Similarity transform", "New coordinates: z = T⁻¹x\nTransformed matrices: Ã=T⁻¹AT, B̃=T⁻¹B, C̃=CT, D̃=D\nTransfer function G(s)=C(sI−A)⁻¹B+D is invariant under T\nEigenvalues invariant; eigenvectors change"],
        ["Controllable canonical form", "A = companion matrix (last row = −[a₀…aₙ₋₁])\nB = [0…0 1]ᵀ;  C = [b₀ b₁…bₙ₋₁]\nDirectly reveals coefficients of characteristic polynomial\nUseful for Ackermann pole-placement"],
        ["Observable canonical form", "Transpose of controllable canonical form\nC = [1 0…0];  A = companion (transposed)\nReveals observability structure directly"],
        ["Modal (diagonal) form", "A = diag(λ₁,…,λₙ)  (if eigenvalues distinct)\nDecoupled scalar equations: żᵢ = λᵢzᵢ + b̃ᵢu\nEach mode zᵢ evolves independently — ideal for analysis and truncation\nB̃ row i: how input excites mode i; C̃ col i: how mode i appears in output"],
        ["Jordan form", "For repeated eigenvalue λ with multiplicity m:\nJordan block Jₘ(λ): λ on diagonal, 1s on superdiagonal\nIndicates near-defective system — high sensitivity to perturbation\nSystem dynamics: polynomial × exponential growth (rᵏ⁻¹eλt)"],
        ["Balanced realisation", "T chosen so Wc = Wo = Σ = diag(σ₁,…,σₙ) (Hankel singular values)\nσᵢ: geometric mean of controllability and observability of each mode\nModes with small σᵢ contribute little to TF — can be truncated safely\nFoundation of model order reduction (balanced truncation)"],
      ]} />

      <h2 style={S.h2}>MIMO Systems in State Space</h2>
      <p style={S.p}>
        The true power of the state-space formulation is its native handling of multi-input multi-output (MIMO) systems. Transfer functions become transfer matrices, and scalar gain design generalises to matrix design — with cross-coupling, directionality, and condition number becoming central concerns.
      </p>
      <Table2 rows={[
        ["Transfer matrix", "G(s) = C(sI−A)⁻¹B + D  (q×p matrix of transfer functions)\nEach element Gᵢⱼ(s) = transfer from input j to output i\nSingle (A,B,C,D) compactly represents all p×q transfer functions"],
        ["Input/output decoupling", "Desired: diagonal G(s) → each output driven by one input only\nDecoupling controller: C(s) such that C(s)G(s) is diagonal\nRequires zeros of G(s) to be in good locations — not always achievable"],
        ["RGA (Relative Gain Array)", "Λ = G(0) ⊗ (G(0)⁻¹)ᵀ  (element-wise product)\nMeasures interaction: Λᵢⱼ=1 → no coupling; Λᵢⱼ≠1 → coupling\nUsed to choose input-output pairing for decentralised PID control"],
        ["Condition number κ(G)", "κ = σ_max/σ_min (ratio of largest to smallest singular value)\nHigh κ: ill-conditioned plant — small input directions produce tiny output\nSensitivity to model uncertainty increases with κ"],
        ["Singular value decomposition", "G(jω) = UΣVᴴ  at each frequency\nPrincipal gains σᵢ: gain in orthogonal input/output directions\nSmallest σ sets limit on achievable disturbance rejection"],
        ["H∞ control", "Minimise ‖T_zw‖_∞ = max_ω σ_max(T_zw(jω))\nWorst-case gain from disturbance w to performance z\nSolved via two coupled Riccati equations — robust to model uncertainty"],
        ["Pole-zero cancellations (MIMO)", "In MIMO, pole-zero cancellations can be non-minimal in unexpected ways\nA cancelled pole may still appear in some transfer functions of G\nState-space reveals all poles; individual Gᵢⱼ(s) may hide some"],
      ]} />

      <h2 style={S.h2}>State Space vs. Transfer Function — When to Use Which</h2>
      <Table2 rows={[
        ["State-space advantages", "Natural for MIMO systems — A,B,C,D handle any number of I/Os\nInitial conditions handled directly in the solution x(t)\nNumerically robust — avoids polynomial arithmetic\nRequired for observer design, LQR, Kalman, H∞, model reduction"],
        ["Transfer function advantages", "Intuitive frequency-domain design (Bode, Nyquist, root locus)\nEasier to visualise loop gain and margins for SISO systems\nConvolution / block diagram algebra is natural\nCustomers / non-specialists more familiar with bandwidth, gain margin"],
        ["Equivalence", "Every LTI SS model has a unique TF (via G=C(sI−A)⁻¹B+D)\nEvery proper rational TF has infinitely many SS realisations\nMinimal realisation: unique up to similarity transform\nOrder = number of poles = dimension of state vector"],
        ["Numerical considerations", "High-order TF polynomials are numerically ill-conditioned\nSS matrices remain well-conditioned for much higher orders\nControl toolboxes (Python-control, MATLAB) work in SS internally even when TF is requested"],
        ["Nonlinear extension", "SS naturally generalises: ẋ = f(x,u), y = h(x,u)\nLinearise at operating point to get local (A,B,C,D)\nTransfer functions have no nonlinear analogue — SS is the only framework"],
      ]} />

      <InfoBox title="Key Formulae Summary" items={[
        "State equation: ẋ = Ax + Bu;   Output equation: y = Cx + Du",
        "Solution: x(t) = eᴬᵗx(0) + ∫₀ᵗ eᴬ⁽ᵗ⁻τ⁾Bu(τ)dτ;   Transfer function: G(s) = C(sI−A)⁻¹B + D",
        "Controllability: rank[B | AB | … | Aⁿ⁻¹B] = n;   Observability: rank[C; CA; …; CAⁿ⁻¹] = n",
        "State feedback: u = r−Kx;   Closed-loop: ẋ = (A−BK)x;   LQR Riccati: AᵀP+PA−PBR⁻¹BᵀP+Q = 0",
        "Observer: x̂˙ = Ax̂+Bu+L(y−Cx̂);   Error: ė = (A−LC)e;   Kalman: L = PCᵀR⁻¹",
        "ZOH: Φ = eᴬᵀ,  Γ = A⁻¹(eᴬᵀ−I)B;   Similarity: Ã=T⁻¹AT, B̃=T⁻¹B, C̃=CT",
        "Eigenvalues: det(λI−A)=0;   trace(A)=Σλᵢ;   det(A)=Πλᵢ;   Lyapunov: AᵀP+PA=−Q",
        "Separation principle: closed-loop poles = eig(A−BK) ∪ eig(A−LC)  (design independently)",
      ]} />
    </div>
  );
}